
$(function() {


    window.topsApp = {
        bindActionEvent: bindActionEvent,
        handleFormSubmission: handleFormSubmission,
        handleSubmission: handleSubmission,
        openWindow: openWindow,
        openWindowWithSubmit: openWindowWithSubmit,
    };

    // グローバルでバリデーションプロバイダーを管理
    window.validationProviders = {};

    // グローバルでアプリケーションイベントを管理
    window.initApplicationEvents = function(container) {
    };

    /**
     * バリデーションプロバイダーを登録
     * @param {string} name - プロバイダー名
     * @param {Function} provider - バリデーション関数
     */
    window.registerValidationProvider = function(name, provider) {
        window.validationProviders[name] = provider;
    };

    
    // グローバルでの初期化
    initEvents(document);
    
    // HTMX対応の初期化
    initHtmxSupport();
    
    /**
     * バリデーション実行
     * @param {jQuery} $button - ボタンのjQueryオブジェクト
     * @returns {boolean} バリデーション結果
     */
    function executeValidation($button) {
        const providerName = $button.data("validate-provider");
        
        if (!providerName) {
            return true; // バリデーション指定がない場合は成功
        }
        
        const provider = window.validationProviders[providerName];
        if (!provider) {
            console.warn(`Validation provider '${providerName}' not found`);
            return true; // プロバイダーが見つからない場合は成功
        }
        
        try {
            return provider($button[0]); // DOM要素を渡す
        } catch (error) {
            console.error(`Validation provider '${providerName}' error:`, error);
            return false;
        }
    }
  
    /**
     * 指定されたコンテナ内の要素にイベントリスナーを設定
     * @param {Element} container - コンテナ要素
     */
    function initEvents(container) {

        // フォーム送信系のイベント
        initFormEvents(container);
        
        // ウィンドウ操作系のイベント
        initWindowEvents(container);
        
        // チェックボックス制御系のイベント
        initCheckboxEvents(container);
        
        // 入力値整形系のイベント
        initInputEvents(container);

        // アプリケーションのイベント
        window.initApplicationEvents(container);
    }

    /**
     * HTMXライブラリのサポート初期化
     */
    function initHtmxSupport() {
        if (window.htmx) {
            htmx.onLoad(function(content) {
                if (!content.tagName) {
                    return;
                }

                // bodyタグの場合は通常で初期化されるので処理しない
                if (content.tagName.toUpperCase() === 'BODY') {
                    return;
                }
                
                const container = $(content);
                if (container.length > 0) {
                    // コンテナ内の要素に対してのみイベントを設定

                    // コンポーネント定義しているイベント
                    initComponents(container.get(0));

                    // フォームコンポーネントのイベント
                    initForms(container.get(0));

                    // システムのイベント
                    initEvents(container.get(0));
                }
            });
        }
    }

    /**
     * フォーム送信の共通処理
     * @param {jQuery} $element - 送信要素のjQueryオブジェクト（ボタンまたはselect等）
     * @param {boolean} isDownload - ダウンロード処理かどうか
     * @param {boolean} isValidate - バリデーション実行かどうか
     * @returns {boolean} 処理結果
     */
    function handleFormSubmission($element, isDownload, isValidate=true) {
        const formId = $element.data("action-form");
        const $form = $(formId);
        
        console.log(`[handleFormSubmission] 要素:`, $element[0], `フォームID: ${formId}, ダウンロード: ${isDownload}`);
        
        // フォームが見つからない場合はエラー
        if ($form.length === 0) {
            console.error(`Form not found: ${formId}`);
            return false;
        }
        
        console.log(`[handleFormSubmission] フォーム見つかりました:`, $form[0]);
        
        // すでに送信中の場合は処理を中止
        if (!isDownload && isFormSubmitting($form, $element)) {
            return false;
        }

        // バリデーション実行
        if(isValidate) {
            if (!executeValidation($element)) {
                return false;
            }
        }

        // 確認メッセージの処理
        if (!confirmAction($element)) {
            return false;
        }

        // フォーム設定
        setupForm($form, $element);

        return handleSubmission($form, $element, isDownload);
    }

    /**
     * フォームが送信中かどうかをチェック
     * @param {jQuery} $form - フォームのjQueryオブジェクト
     * @param {jQuery} $element - 要素のjQueryオブジェクト
     * @returns {boolean} 送信中かどうか
     */
    function isFormSubmitting($form, $element) {
        // フォーム自体が送信中かチェック
        if ($form.data('submitting')) {
            return true;
        }
        
        // 要素がボタンの場合はdisabled状態もチェック
        if ($element.is('button, input[type="submit"], input[type="button"]')) {
            return $element.prop('disabled');
        }
        
        return false;
    }

    /**
     * 確認ダイアログの表示
     * @param {jQuery} $element - 要素のjQueryオブジェクト
     * @returns {boolean} 確認結果
     */
    function confirmAction($element) {
        const confirmMessage = $element.data("action-confirm");
        if (confirmMessage) {
            return confirm(confirmMessage);
        }
        return true;
    }

    /**
     * フォームの設定
     * @param {jQuery} $form - フォームのjQueryオブジェクト
     * @param {jQuery} $element - 要素のjQueryオブジェクト
     */
    function setupForm($form, $element) {
        const url = $element.data("action-url");
        const formMethod = $element.data("action-method");
        
        if (url) {
            $form.attr('action', url);
        }
        $form.attr('method', formMethod || "post");
    }

    /**
     * フォーム送信の実行
     * @param {jQuery} $form - フォームのjQueryオブジェクト
     * @param {jQuery} $element - 要素のjQueryオブジェクト
     * @param {boolean} isDownload - ダウンロード処理かどうか
     * @returns {boolean} 処理結果
     */
    function handleSubmission($form, $element, isDownload) {
        // UI要素を無効化（ダウンロード以外）
        if (!isDownload) {
            setLoadingState($element, true);
            setFormSubmittingState($form, true);
            
            // 一定時間後にフォームの送信状態をリセット
            setTimeout(() => {
                setFormSubmittingState($form, false);
                setLoadingState($element, false);
            }, 5000); // 5秒後にリセット
        }

        $form.submit();
        return false;
    }

    /**
     * フォームの送信状態を設定
     * @param {jQuery} $form - フォームのjQueryオブジェクト
     * @param {boolean} isSubmitting - 送信中かどうか
     */
    function setFormSubmittingState($form, isSubmitting) {
        $form.data('submitting', isSubmitting);
        $form.find('button[type="submit"]').prop('disabled', isSubmitting);
    }

    /**
     * 要素のローディング状態を設定
     * @param {jQuery} $element - 要素のjQueryオブジェクト
     * @param {boolean} isLoading - ローディング中かどうか
     */
    function setLoadingState($element, isLoading) {
        // ボタン要素の場合のみdisabled状態を設定
        if ($element.is('button, input[type="submit"], input[type="button"]')) {
            $element.prop('disabled', isLoading);
        }
        
        if (isLoading) {
            $element.addClass('submit-request');
        } else {
            $element.removeClass('submit-request');
        }
    }

    /**
     * フォーム送信系の処理（clear, filter）
     * @param {jQuery} $button - ボタンのjQueryオブジェクト
     * @returns {boolean} 処理結果
     */
    function handleFormAction($button) {
        const url = $button.data("action-url");
        const formSelector = $button.data("action-form");
        
        // HTMX処理
        if (url === 'htmx') {
            const form = document.querySelector(formSelector || "form");
            form.dispatchEvent(new Event('submit'));
            return true;
        }

        // すでに送信中の場合は処理を中止
        if ($button.prop('disabled')) {
            return false;
        }

        // UI要素を無効化
        setLoadingState($button, true);
        
        // フォーム送信
        const form = document.querySelector(formSelector || "form");
        form.action = url;
        form.submit();
        return false;
    }

    /**
     * ウィンドウを開く処理
     * @param {jQuery} $button - ボタンのjQueryオブジェクト
     */
    function openWindow($button) {
        const path = $button.data("link") || $button.attr("link");
        const target = $button.data("target");
        const width = $button.data("width") || "800";
        const height = $button.data("height") || "600";
        
        const windowFeatures = `scrollbars=yes,resizable=yes,status=no,menubar=no,width=${width},height=${height}`;
        
        if (target) {
            window.open(path, target, windowFeatures);
        } else {
            window.open(path, "", windowFeatures);
        }
    }

    /**
     * フォームを新規ウィンドウに送信する処理
     * @param {jQuery} $button - ボタンのjQueryオブジェクト
     * @returns {boolean} 処理結果
     */
    function openWindowWithSubmit($button) {
        const path = $button.data("action-url") || $button.attr("action-url");
        const target = $button.data("target");
        const width = $button.data("width") || "800";
        const height = $button.data("height") || "600";
        
        const windowFeatures = `scrollbars=yes,resizable=yes,status=no,menubar=no,width=${width},height=${height}`;
        
        let newWindow;
        if (target) {
            newWindow = window.open('', target, windowFeatures);
        } else {
            newWindow = window.open('', "", windowFeatures);
        }
        
        const formId = $button.data("action-form");
        const form = document.querySelector(formId || "form");
        form.action = path;
        form.target = newWindow.name;
        form.submit();
        return false;
    }


    /**
     * フォーム送信系のイベント初期化
     * @param {Element} container - コンテナ要素
     */
    function initFormEvents(container) {
        // 通常送信
        bindActionEvent(container, 'submit', function() {
            return handleFormSubmission($(this), false);
        });
    
        // ダウンロード送信
        bindActionEvent(container, 'download', function() {
            return handleFormSubmission($(this), true);
        });
    
        // クリア送信
        bindActionEvent(container, 'clear', function() {
            return handleFormAction($(this));
        });
    
        // フィルター送信
        bindActionEvent(container, 'filter', function() {
            return handleFormAction($(this));
        });

        // HTMX送信
        bindActionEvent(container, 'htmx', function() {
            const $button = $(this);
            const formSelector = $button.data("action-form");
            const form = document.querySelector(formSelector || "form");
            form.dispatchEvent(new Event('submit'));
            return true;
        });

    }

    /**
     * data-action属性とdata-action-event属性に基づいてイベントをバインド
     * @param {Element} container - コンテナ要素
     * @param {string} action - アクション名
     * @param {Function} handler - イベントハンドラー
     */
    function bindActionEvent(container, action, handler) {
        const selector = `[data-action='${action}']`;
        $(selector, container).each(function() {
            const $element = $(this);
            const eventType = $element.data("action-event") || "click";
            
            // イベントバインド情報をコンソールに出力
            const elementInfo = {
                tagName: this.tagName.toLowerCase(),
                id: this.id || '(no id)',
                className: this.className || '(no class)',
                action: action,
                eventType: eventType,
                element: this
            };
            console.log(`[bindActionEvent] ${elementInfo.tagName}#${elementInfo.id}.${elementInfo.className} に ${eventType} イベントで ${action} アクションを設定`, elementInfo);
            $element.on(eventType, handler);
        });
    }

    /**
     * ウィンドウ操作系のイベント初期化
     * @param {Element} container - コンテナ要素
     */
    function initWindowEvents(container) {
        // 新規ウィンドウ表示
        bindActionEvent(container, 'openWindow', function() {
            openWindow($(this));
        });

        // フォーム送信付きウィンドウ表示
        bindActionEvent(container, 'openWindowWithSubmit', function() {
            return openWindowWithSubmit($(this));
        });
    }

    // input cnahge control

    /**
     * 入力値整形系のイベント初期化
     * @param {Element} container - コンテナ要素
     */
    function initInputEvents(container) {
        // 空白除去
        $("input[data-provider='left-pno']", container).blur(function() {
            formatInputValue($(this));
        });
    }

    /**
     * 入力値の整形処理
     * @param {jQuery} $input - 入力要素のjQueryオブジェクト
     */
      function formatInputValue($input) {
        const value = $input.val();
        $input.val(value.replace(/\s+/g, ""));
    }


    // checkbox control
    
    /**
     * チェックボックスの一括制御
     * @param {jQuery} $button - ボタンのjQueryオブジェクト
     * @param {boolean} checkAll - 全選択かどうか
     * @returns {boolean} 処理結果
     */
    function handleCheckboxControl($button, checkAll) {
        const provider = $button.data("provider-name") || "checkAll";
        //const container = $button.closest('form, div').length > 0 ? $button.closest('form, div') : $(document);
        //$(`input[data-provider='${provider}']`, container).prop("checked", checkAll);
        $(`input[data-provider="${provider}"]`).prop("checked", checkAll);
        return false;
    }

    /**
     * チェックボックス制御系のイベント初期化
     * @param {Element} container - コンテナ要素
     */
    function initCheckboxEvents(container) {
        // 全選択
        bindActionEvent(container, 'checkAll', function() {
            return handleCheckboxControl($(this), true);
        });
    
        // 全解除
        bindActionEvent(container, 'uncheckAll', function() {
            return handleCheckboxControl($(this), false);
        });
    }

});

